import { render, staticRenderFns } from "./PosProfilesTable.vue?vue&type=template&id=1f562ce6"
import script from "./PosProfilesTable.vue?vue&type=script&lang=js"
export * from "./PosProfilesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports